/** Marks a toolbar + table pair for opt-in search ↔ first-row keyboard navigation. */
export const DATA_TABLE_TOOLBAR_KEYBOARD_NAV_ATTR = 'data-datatable-toolbar-keyboard-nav';

export const DATA_TABLE_FIRST_ROW_SELECTOR = 'tbody tr[data-row-index="0"]';

export const AR_COMPANY_FIRST_ROW_SELECTOR = 'tbody tr[data-ar-company="true"][data-ar-group-index="0"]';

export function focusFirstRowInToolbarNavRoot(
  navRoot: Element | null | undefined,
  firstRowSelector = DATA_TABLE_FIRST_ROW_SELECTOR
): boolean {
  if (!navRoot) {
    return false;
  }

  const row = navRoot.querySelector<HTMLElement>(firstRowSelector);
  if (!row) {
    return false;
  }

  row.focus();
  return true;
}
